import { v4 as uuidV4 } from 'uuid';

const BUILD_VERSION = `${import.meta.env.VITE_BUILD_VERSION || '0.0.0 - dev'}`;
const ROOT_API_URL = `${import.meta.env.VITE_API_URL}`;
const ROOT_NXTROOM_URL = `${import.meta.env.VITE_NXTROOM_URL}`;
const SOCKET_URL = `${import.meta.env.VITE_SOCKET_URL}/chat`;
const FRONT_URL = `${import.meta.env.VITE_FRONT_URL || 'http://localhost:8080/'}`;
const LOGIN_URL = `${import.meta.env.VITE_OKTA_URL}/oauth2/v1/authorize?client_id=${import.meta.env.VITE_CLIENT_ID}&response_type=id_token&response_mode=fragment&scope=openid+profile+email+groups&redirect_uri=${import.meta.env.VITE_FRONT_URL}openid&nonce=${uuidV4()}&state=Commuter`;
const LOGOUT_URL = 'https://fedpoc.jll.com/smagent/SM/Logout?signOutUrl=https://jllpoc.oktapreview.com/login/signout';
const GMAPS_APIKEY = `${import.meta.env.VITE_GMAPS_APIKEY}`;
const AQICN_API_KEY = `${import.meta.env.VITE_AQICN_API_KEY}`;

export default {
  BUILD_VERSION,
  API_URL: ROOT_API_URL,
  NXTROOM_URL: ROOT_NXTROOM_URL,
  SOCKET_URL,
  GMAPS_APIKEY,
  LOGIN_URL,
  LOGOUT_URL,
  FRONT_URL,
  AQICN_API_KEY,
};
